/* AddEditImageServerRenderer.js */

"use strict";
const uiCore = require("@gluenetworks/steve_ui_core");
const CheckboxControl = uiCore.Control.Boolean.InputCheckbox;
const ButtonControl = uiCore.Control.Action.Button;
const InputTextControl = uiCore.Control.Textfield.InputText;
const _ = require("lodash");
//const InputPWControl = uiCore.Control.Textfield.InputPassword;
//const InputNumberControl = uiCore.Control.Textfield.InputNumber;
//const ComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;

const MODAL_TITLE_ADD = "File Server Settings";
const FILE_SERVER_WARNING =
    "WARNING - Please ensure that this file server is online and reachable prior to adding to OS Management";

class AddEditImageServerRenderer {
    constructor(model, initialData) {
        this._model = model;
        this._rootElem = this._createRootElement();

        this._errorContainer = document.createElement("div");
        this._errorContainer.classList.add("error");

        this._warningMessage = document.createElement("p");
        this._warningMessage.innerText = FILE_SERVER_WARNING;
        this._warningMessage.className = "warning";

        this._initialData = initialData;

        /* form controls */
        this.enableFileServerCheckbox = new CheckboxControl({
            darkTheme: true,
            labelShown: true,
            label: "Enable File Server",
        });
        this.serverNameText = new InputTextControl({
            darkTheme: true,
            invalid: false,
            placeholder: "Name",
        });
        this.idText = new InputTextControl({
            darkTheme: true,
            invalid: false,
            placeholder: "ID",
        });
        this.serverIPText = new InputTextControl({
            darkTheme: true,
            invalid: false,
            placeholder: "IPv4 Address",
            label: "IPv4 Address",
        });
        this.serverIPv6Text = new InputTextControl({
            darkTheme: true,
            invalid: false,
            placeholder: "IPv6 Address",
            label: "IPv6 Address",
        });
        this.fileServerCredentialText = new InputTextControl({
            darkTheme: true,
            invalid: false,
            disabled: true,
            placeholder: "File Transfer Credential",
            label: "File Transfer Credential",
        });

        /*
        //Commented out because we no longer use file server proxy ( Case 27330 )
        // Proxy List
        this.proxyList = [{}];
        this.proxyList[0].ip = new InputTextControl({
            darkTheme: true,
            invalid: false,
            placeholder: "IP Address",
            label: "IP Address"
        });
        this.proxyList[0].userName = new InputTextControl({
            darkTheme: true,
            invalid: false,
            placeholder: "User Name",
            label: "User Name"
        });
        this.proxyList[0].password = new InputPWControl({
            darkTheme: true,
            invalid: false,
            placeholder: "Password",
            label: "Password"
        });

         */

        // Commented because only SSH is supported (case 24349)
        /*
        this.proxyList[0].type = new ComboBoxControl({
            darkTheme: true,
            invalid: false,
            placeholder: "SSH",
            showFilter: false,
            adjustWidth: true,
            options: [{value: 'SSH', label: 'SSH'},
                      {value: 'telnet', label: 'telnet'}],
            selectedOption: {value: 'SSH', label: 'SSH'},
            label: "Type"
        });
        this.proxyList[0].port = new InputNumberControl({
            darkTheme: true,
            invalid: false,
            placeholder: "22",
            label: "Port",
            min: 0,
            max: 65535,
            onlyInteger: true
        });
        */

        this.cancelButton = new ButtonControl({
            label: "Cancel",
            darkTheme: true,
            disabled: false,
        });

        this.saveButton = new ButtonControl({
            label: "Save",
            darkTheme: true,
            disabled: true,
        });

        if (initialData) {
            this._setData(initialData);
        }

        this._registerListeners();
        this.render();
    }

    get rootElement() {
        return this.getRootElement();
    }

    get model() {
        return this.getModel();
    }

    /*******************************************/
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    render() {
        if (this._renderProm === null) {
            return Promise.resolve();
        }
        this._renderProm = this._renderProm || this._render();
        return this._renderProm;
    }

    shutdown() {
        if (this._shutdownProm === null) {
            return Promise.resolve();
        }
        this._shutdownProm = this._shutdownProm || this._shutdown();
        return this._shutdownProm;
    }

    getRootElement() {
        return this._rootElem;
    }

    getModel() {
        return this._model;
    }

    /********************************************/
    /* END PUBLIC COMPONENT RENDERER METHODS */
    /* START PRIVATE COMPONENT RENDERER METHODS */

    /********************************************/

    _registerListeners() {
        this._model.on("Data", (this._onData = this._onData.bind(this)));
        this.enableFileServerCheckbox.on("UserValue", this._onOtherValueChange.bind(this));
        this.serverNameText.on("UserValue", this._onOtherValueChange.bind(this));
        this.idText.on("UserValue", this._onOtherValueChange.bind(this));
        this.serverIPText.on("UserValue", this._onOtherValueChange.bind(this));
        this.serverIPv6Text.on("UserValue", this._onOtherValueChange.bind(this));
        /*
        //proxyList
        this.proxyList[0].ip.on("UserValue", this._onOtherValueChange.bind(this));
        this.proxyList[0].userName.on("UserValue", this._onOtherValueChange.bind(this));
        this.proxyList[0].password.on("UserValue", this._onOtherValueChange.bind(this));
        //this.proxyList[0].type.on("UserValue", this._onTypeChange.bind(this));
        //this.proxyList[0].port.on("UserValue", this._onOtherValueChange.bind(this));

         */

        this.saveButton.on("UserClick", this.submitAction.bind(this));
        this.cancelButton.on("UserClick", this.cancelAction.bind(this));
        this._model.on("Error", this._onError.bind(this));
    }

    _unregisterListeners() {
        this._model.removeListener("Data", this._onData);
        this.enableFileServerCheckbox.removeAllListeners("UserValue");
        this.serverNameText.removeAllListeners("UserValue");
        this.idText.removeAllListeners("UserValue");
        this.serverIPText.removeAllListeners("UserValue");
        this.serverIPv6Text.removeAllListeners("UserValue");
        /*
        // Proxy List
        this.proxyList[0].ip.removeAllListeners("UserValue");
        this.proxyList[0].userName.removeAllListeners("UserValue");
        this.proxyList[0].password.removeAllListeners("UserValue");
        //this.proxyList[0].type.removeAllListeners("UserValue");
        //this.proxyList[0].port.removeAllListeners("UserValue");

         */

        this.saveButton.removeAllListeners("UserClick");
        this.cancelButton.removeAllListeners("UserClick");
        this._model.removeAllListeners("Error");
    }

    _render() {
        const root = document.createDocumentFragment();
        const title = document.createElement("h2");
        title.innerText = MODAL_TITLE_ADD;

        root.appendChild(title);
        root.appendChild(this._warningMessage);
        root.appendChild(this._createForm());
        root.appendChild(this._errorContainer);

        return new Promise((resolve /*,reject*/) => {
            this._rootElem.appendChild(root);
            resolve();
        });
    }

    _shutdown() {
        this._unregisterListeners();
        this._rootElem.remove();
        this._rootElem = null;

        return Promise.all([
            this.enableFileServerCheckbox.shutdown(),
            this.serverNameText.shutdown(),
            this.idText.shutdown(),
            this.serverIPText.shutdown(),
            this.serverIPv6Text.shutdown(),
            this.fileServerCredentialText.shutdown(),
            this.cancelButton.shutdown(),
            this.saveButton.shutdown(),
        ])
            .then(() => {
                this._model = null;
                this._shutdownProm = null;
                this._renderProm = null;
                this.enableFileServerCheckbox = undefined;
                this.serverNameText = undefined;
                this.idText = undefined;
                this.serverIPText = undefined;
                this.serverIPv6Text = undefined;
                this.fileServerCredentialText = undefined;
                this.proxyList = undefined;
            })
            .catch((error) => {
                console.log(`${this.constructor.name}: error in shutdown`);
                console.error(error);
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PRIVATE RENDERER METHODS          */
    /*******************************************/

    _createRootElement() {
        const rootElement = document.createElement("div");
        rootElement.classList.add("add-edit-image-server", "modal_feedback_container");
        rootElement.component = this._model;
        return rootElement;
    }

    _createSection(content, options = {}) {
        const section = document.createElement("section");
        section.className = options.className || "";
        section.classList.toggle("bordered", !!options.bordered);

        if (options.title) {
            const title = document.createElement("h2");
            title.innerText = options.title;
            section.appendChild(title);
        }
        section.appendChild(content);
        return section;
    }

    _createForm() {
        const formRoot = document.createDocumentFragment();
        const serverNameLabel = document.createElement("label");
        serverNameLabel.innerText = "Name";

        const idLabel = document.createElement("label");
        idLabel.innerText = "ID";

        const serverIPLabel = document.createElement("label");
        serverIPLabel.innerText = "IPv4 Address";

        const serverIPv6Label = document.createElement("label");
        serverIPv6Label.innerText = "IPv6 Address";

        const fileServerCredLabel = document.createElement("label");
        fileServerCredLabel.innerText = "File Transfer Credential";

        /*
        // ProxyList
        const proxySection = document.createDocumentFragment();
        const proxyIPLabel = document.createElement("label");
        proxyIPLabel.innerText = "IP Address";

        const proxyUserNameLabel = document.createElement("label");
        proxyUserNameLabel.innerText = "User Name";

        const proxyPasswordLabel = document.createElement("label");
        proxyPasswordLabel.innerText = "Password";

        const proxyContainer = document.createElement("div");
        proxyContainer.classList.add("proxy-container");

        //proxyList type and port section
        //const proxyTypePort = document.createDocumentFragment();

        //const proxyTypeLabel = document.createElement("label");
        //proxyTypeLabel.innerText = "Type";

        //const proxyPortLabel = document.createElement("label");
        //proxyPortLabel.innerText = "Port";

        //proxyTypePort.appendChild(proxyTypeLabel);
        //proxyTypePort.appendChild(this.proxyList[0].type.renderer.getRootElement());

        //proxyTypePort.appendChild(proxyPortLabel);
        //proxyTypePort.appendChild(this.proxyList[0].port.renderer.getRootElement());

        proxyContainer.appendChild(proxyIPLabel);
        proxyContainer.appendChild(this.proxyList[0].ip.renderer.getRootElement());
        proxyContainer.appendChild(proxyUserNameLabel);
        proxyContainer.appendChild(this.proxyList[0].userName.renderer.getRootElement());
        proxyContainer.appendChild(proxyPasswordLabel);
        proxyContainer.appendChild(this.proxyList[0].password.renderer.getRootElement());

         */

        /*
        proxyContainer.appendChild(this._createSection(proxyTypePort, {
            className: "proxy-section-type-port",
            bordered: true
        }));
        */

        const actionsContainer = document.createElement("div");
        actionsContainer.classList.add("actions-container");
        actionsContainer.appendChild(this.cancelButton.renderer.getRootElement());
        actionsContainer.appendChild(this.saveButton.renderer.getRootElement());

        formRoot.appendChild(this.enableFileServerCheckbox.renderer.getRootElement());
        formRoot.appendChild(serverNameLabel);
        formRoot.appendChild(this.serverNameText.renderer.getRootElement());
        formRoot.appendChild(idLabel);
        formRoot.appendChild(this.idText.renderer.getRootElement());
        formRoot.appendChild(serverIPLabel);
        formRoot.appendChild(this.serverIPText.renderer.getRootElement());
        formRoot.appendChild(serverIPv6Label);
        formRoot.appendChild(this.serverIPv6Text.renderer.getRootElement());
        formRoot.appendChild(fileServerCredLabel);
        formRoot.appendChild(this.fileServerCredentialText.renderer.getRootElement());

        /*
        // Proxy List
        proxySection.appendChild(proxyContainer);
        formRoot.appendChild(this._createSection(proxySection, {
            title: "Proxy",
            className: "proxy-section",
            bordered: true
        }));

         */

        formRoot.appendChild(actionsContainer);

        return formRoot;
    }

    /*******************************************/
    /* END PRIVATE RENDERER METHODS            */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onData(data = {}) {
        this._setData(data);
    }

    _onEnabledChange() {
        this._checkSaveButton();
    }

    _onINameChange() {
        this._checkSaveButton();
    }

    _onIdentifierChange() {
        this._checkSaveButton();
    }

    _onIPChange() {
        this._checkSaveButton();
    }

    /*
    _onTypeChange() {
        const type = this.proxyList[0].type.value;

        // ssh = 22, telnet = 23
        if(type === "SSH") {
            this.proxyList[0].port.value = 22;
        }
        else {
            this.proxyList[0].port.value = 23;
        }

        this._checkSaveButton();
    }
    */

    _onOtherValueChange() {
        this._checkSaveButton();
    }

    _onError(errorMsg) {
        this._setError(errorMsg);
        this._checkSaveButton(false);
    }

    submitAction() {
        const data = this._getFormData();
        this._model.submit(data);
    }

    cancelAction() {
        this._model.closePopUp();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _getFormData() {
        const formData = {
            enabled: Boolean(this.enableFileServerCheckbox.value),
            name: this.serverNameText.value,
            identifier: this.idText.value,
            ip: this.serverIPText.value,
            ipv6: this.serverIPv6Text.value,

            /*
            //proxyList
            proxyList: [{
                ip: this.proxyList[0].ip.value,
                userName: this.proxyList[0].userName.value,
                password: this.proxyList[0].password.value
                //type: this.proxyList[0].type.value,
                //port: this.proxyList[0].port.value
            }]

             */
        };
        return formData;
    }

    _setData(data) {
        //let proxyListEl = document.getElementsByClassName('proxy-section');
        this.enableFileServerCheckbox.setValue(!!data.enabled).setDisabled(data.isMain);
        this.serverNameText.setValue(data.name);
        this.idText.setValue(data.identifier).setDisabled(data.isMain);
        this.serverIPText.setValue(data.ip);
        this.serverIPv6Text.setValue(data.ipv6);

        this.fileServerCredentialText.setValue(this._model._fileServerCredentialName);

        /*
        // Proxy List
        if (!data.isMain && proxyListEl.length > 0) {
            proxyListEl[0].style.display = 'none';
        }

        if (data.proxyList && data.proxyList[0] && this.proxyList[0] ) {
            this.proxyList[0].ip.setValue(data.proxyList[0].ip);
            this.proxyList[0].userName.setValue(data.proxyList[0].userName);
            this.proxyList[0].password.setValue(data.proxyList[0].password);
            //this.proxyList[0].type.setValue(data.proxyList[0].type);
            //this.proxyList[0].port.setValue(data.proxyList[0].port);
        }

         */

        this._warningMessage.classList.toggle("hidden", !this.model.fileServerIsNew);
    }

    _checkSaveButton() {
        const formData = this._getFormData();
        const initialData = this._initialData;
        let disableSave = true;

        if (
            formData.enabled !== initialData.enabled ||
            formData.name !== initialData.name ||
            formData.identifier !== initialData.identifier ||
            formData.ip !== initialData.ip ||
            formData.ipv6 !== initialData.ipv6
        ) {
            if (
                !_.isEmpty(formData.name.trim()) &&
                !_.isEmpty(formData.identifier.trim()) &&
                this._validateIPs(formData.ip, formData.ipv6)
            ) {
                disableSave = false;
            }
        }

        this.saveButton.setDisabled(disableSave);
    }

    _validateIPs(ipv4 = "", ipv6 = "") {
        const ipv4Regex =
            /^(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]{1,2})(\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]{1,2})){3}$/;
        const ipv6Regex =
            /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/i;

        if (ipv4Regex.test(ipv4) && _.isEmpty(ipv6.trim())) {
            return true;
        }

        if (ipv6Regex.test(ipv6) && _.isEmpty(ipv4.trim())) {
            return true;
        }

        if (ipv4Regex.test(ipv4) && ipv6Regex.test(ipv6)) {
            return true;
        }

        return false;
    }

    _setError(error) {
        let errorStr = "Error";
        if (typeof error === "string") {
            errorStr = error;
        } else if (error instanceof Error) {
            errorStr = error.toString();
        } else if (error && error.errorMsg) {
            const errorCode = error.errorCode || "Error";
            const errorMsg = error.errorMsg;
            errorStr = `${errorCode}: ${errorMsg}`;
        }
        this._errorContainer.innerText = errorStr;
    }

    _clearError() {
        this._errorContainer.innerText = "";
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = AddEditImageServerRenderer;
